<template>
  <!-- <a-layout-header :class="[theme,fixHeader && 'ant-header-fixedHeader', layout === 'side' ? (sidebarOpened ? 'ant-header-side-opened' : 'ant-header-side-closed') : null, theme, 'global-header' ]"> -->
  <a-layout-header :class="[theme, layout === 'side' ? (sidebarOpened ? 'ant-header-side-opened' : 'ant-header-side-closed') : null, theme, 'global-header' ]">
    <div :class="['global-header-wide', layout]">
      <router-link v-if="isMobile || layout === 'head'"
                   to="/"
                   :class="['logo', isMobile ? null : 'pc', theme]">
        <!-- <img width="32" src="static/img/logo.png"  alt=""/> -->
        <h1 v-if="!isMobile">{{systemName}}</h1>
      </router-link>
      <a-divider v-if="isMobile"
                 type="vertical" />
      <img :src="systemIcon"
           alt="">
      <span class="sys-title">{{systemName}}</span>
      <!-- <a-icon v-if="layout === 'side'" class="trigger" :type="collapsed ? 'menu-unfold' : 'menu-fold'" @click="toggleCollapse"/> -->
      <div v-if="layout === 'head'"
           class="global-header-menu">
        <menu-bar style="height: 64px; line-height: 64px;"
                  class="system-top-menu"
                  :theme="theme"
                  mode="horizontal"
                  :menuData="menuData"
                  @select="onSelect" />
      </div>
      <div :class="['global-header-right', theme]">
        <header-avatar class="header-item" />
      </div>
    </div>
  </a-layout-header>
</template>

<script>
import HeaderAvatar from "./HeaderAvatar";
// import IMenu from '@/components/menu/menu'
import MenuBar from "@/components/menu/MenuBar";
import { mapState } from "vuex";

export default {
  name: "GlobalHeader",
  components: { MenuBar, HeaderAvatar },
  props: ["collapsed", "menuData"],
  computed: {
    ...mapState({
      isMobile: (state) => state.setting.isMobile,
      layout: (state) => state.setting.layout,
      systemName: (state) => state.setting.systemName,
      sidebarOpened: (state) => state.setting.sidebar.opened,
      fixHeader: (state) => state.setting.fixHeader,
      systemIcon: (state) => state.setting.systemIcon,
    }),
    theme() {
      return this.$store.state.setting.theme;
      // return this.layout === 'side' ? 'light' : this.$store.state.setting.theme
    },
  },
  methods: {
    toggleCollapse() {
      this.$store.commit("business/toggleCollapse", new Date());
      this.$emit("toggleCollapse");
    },
    onSelect(obj) {
      this.$emit("menuSelect", obj);
    },
  },
};
</script>

<style lang="less" scoped>
.trigger {
  font-size: 20px;
  line-height: 64px;
  padding: 0 24px;
  cursor: pointer;
  transition: color 0.3s;
  color: #fff;
}
.header-item {
  padding: 0 19px;
  display: inline-block;
  height: 100%;
  cursor: pointer;
  vertical-align: middle;
  i {
    font-size: 16px;
    color: rgba(0, 0, 0, 0.65);
  }
}
.global-header {
  padding: 0 12px 0 0;
  -webkit-box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
  // position: relative;
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  z-index: 99999;
  &.light {
    // background: #fff;
    background: #004290;
    color: #fff;
  }
  &.dark {
    background: #393e46;
  }
  .global-header-wide {
    &.head {
      padding: 0 24px;
    }
    &.side {
    }
    .logo {
      height: 64px;
      line-height: 58px;
      vertical-align: top;
      display: inline-block;
      padding: 0 12px 0 24px;
      cursor: pointer;
      font-size: 20px;
      &.pc {
        padding: 0 12px 0 0;
      }
      img {
        display: inline-block;
        vertical-align: middle;
      }
      h1 {
        display: inline-block;
        font-size: 16px;
        color: #fff;
      }
      // &.dark h1{
      //   color: #fff;
      // }
    }
    .global-header-menu {
      display: inline-block;
    }
    .global-header-right {
      float: right;
      &.dark {
        color: #fff;
        i {
          color: #fff;
        }
      }
    }
  }
}
.ant-header-fixedHeader {
  position: fixed;
  top: 0;
  right: 0;
  z-index: 15;
  width: 100%;
  transition: width 0.2s;

  &.ant-header-side-opened {
    width: 100%;
    padding-left: 254px;
  }

  &.ant-header-side-closed {
    width: 100%;
    padding-left: 80px;
  }
}
.target {
  color: #ccc;
  text-decoration: none;
  padding-left: 10px;
}
.target:hover {
  color: #fff;
}
.sys-title {
  color: #fff;
  font-size: 18px;
  margin: 0 0 0 0px;
  font-family: Chinese Quote, -apple-system, BlinkMacSystemFont, Segoe UI,
    PingFang SC, Hiragino Sans GB, Microsoft YaHei, Helvetica Neue, Helvetica,
    Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol;
  font-weight: 600;
  display: inline-block;
  height: 32px;
  line-height: 32px;
  vertical-align: middle;
}
img {
  width: 32px;
  display: inline-block;
  vertical-align: middle;
  margin-left: 15px;
}
</style>



// WEBPACK FOOTER //
// src/views/common/GlobalHeader.vue